/**
 * 只放所有版型都可能用到的功能
 */

import { defineStore } from '@/utils/store'
import { isDev } from '@/env'

type State = {
  /** 部分版型 Header 有按鈕，可隱藏按鈕 */
  hideHeaderNavbar: boolean
  /** 側邊欄是否顯示 */
  sidebar: boolean
  /** 客服是否顯示 */
  customerService: boolean
}

/** 所有版型通用的 UI 邏輯 */
export const [useUIStore, setUIState] = defineStore<State>(
  {
    hideHeaderNavbar: false,
    sidebar: false,
    customerService: false,
  },
  {
    name: 'UI_STORE',
    partialize: (state) => {
      if (isDev) {
        // 開發環境也排除 customerService
        const { customerService, ...rest } = state
        return rest as State
      }
      // 正式環境的部分 UI 重整要重置
      return {} as State
    },
  },
)
